import { render, staticRenderFns } from "./TW1.vue?vue&type=template&id=43567fc9"
import script from "./TW1.vue?vue&type=script&lang=js"
export * from "./TW1.vue?vue&type=script&lang=js"
import style0 from "./TW1.vue?vue&type=style&index=0&id=43567fc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports